import { render } from "./ShippingMethodIntegration.vue?vue&type=template&id=48e2569e&scoped=true&ts=true"
import script from "./ShippingMethodIntegration.vue?vue&type=script&lang=ts"
export * from "./ShippingMethodIntegration.vue?vue&type=script&lang=ts"

import "./ShippingMethodIntegration.vue?vue&type=style&index=0&id=48e2569e&scoped=true&lang=css"

import exportComponent from "D:\\YellowBeardProject\\keisi\\keisishopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48e2569e"]])

export default __exports__